import React from 'react'
import { CMSEntries } from 'mage-cms'
import TopicList from './TopicList'

export default function AllTopicsList() {
  return (
    <CMSEntries contentType="UHQMTopic">
      {topics => <TopicList topics={topics} analyticsCategory="uhqm/topic-title/all" limit={6} />}
    </CMSEntries>
  )
}
